<div class="pdf-page app-aul-013-24" id="alaska1324">
  <!-- <app-policy-header></app-policy-header> -->
  <br />
  <p class="font-large" style="text-align: center">
    <b>AMENDATORY ENDORSEMENT</b>
  </p>
  <p class="font-large" style="text-align: center"><b>ALASKA CHANGES</b></p>
  <p class="font-large" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>
  <p class="font-medium">
    <b
      >This endorsement comprising of policyholder notices, coverage changes and
      endorsements attaches to and forms part of the policy numbered
      {{ this.policyDetails?.policyNo }}
    </b>
  </p>
  <br />
  <br />
  <p class="font-medium" style="text-decoration: underline">
    <b><u>SURPLUS LINES DISCLOSURE NOTICE</u></b>
  </p>
  <p class="font-medium" style="text-align: justify; width: 95%;">
    <b>
      This is evidence of insurance procured and developed under Alaska Surplus
      Lines Law, AS 21.34. It is not covered by the Alaska Insurance Guaranty
      Association Act, AS 21.80
    </b>
  </p>
  <br />
  <p class="font-medium">
    <b><u>POLICYHOLDER NOTICE</u></b>
  </p>
  <p class="font-medium">
    <b>
      This policy is issued by a nonadmitted or surplus lines insurer. Insurance
      may only be purchased from nonadmitted insurers if the full amount, kind,
      or class of insurance cannot be obtained from insurers who are admitted to
      do business in the State of Alaska.
    </b>
  </p>
  <br />
  <p class="font-medium">
    <b>
      Your broker or the surplus lines broker has determined that this was true
      on the date the policy was placed. Before issuing a renewal policy or
      extending this policy, remarketing is required. To avoid intentional or
      unintentional extension of coverage in the surplus lines market when an
      admitted market for that coverage exists, a nonadmitted insurer is
      prohibited from the automatic renewal or extension of a policy without
      remarketing by your broker or the surplus lines broker.
    </b>
  </p>
  <br />
  <p class="font-medium">
    <b>
      You are hereby notified that, under 3 AAC 25.050, your policy will
      terminate effective no later than the date and time of its expiration. We
      reserve the right to cancel this policy sooner than the expiration date by
      giving you notice of cancellation as required in AS 21.36.220. You may
      request through your broker that a new policy from the surplus lines
      broker be concurrent with the effective date of the termination of this
      policy. You are also notified that a new policy, if issued by us, is
      subject to rerating, which may result in a premium increase of more than
      ten percent (10%).
    </b>
  </p>
  <br />
  <p class="font-medium">
    <b>
      As required by 3 AAC 25.050, you are hereby notified that any subsequent
      policy issued by us may be subject to a ten percent (10%) or more increase
      in premium. The actual premium will be based upon rates that apply at the
      time a subsequent policy, if any, is issued and will be made available to
      you before the effective date of the new policy, or the date subsequent
      coverage is bound, whichever occurs first.
    </b>
  </p>
</div>
<div class="pdf-page app-aul-013-24" id="alaska1324">

  <div>
    <div>
      <p class="font-medium">
        <b
          ><span style="text-decoration: underline"
            >SERVICE OF SUIT CLAUSE</span
          ></b
        >
      </p>
    </div>
    <div>
      <p class="font-medium">
        <u>FORTEGRA SPECIALTY INSURANCE COMPANY</u>
      </p>
    </div>
    <ol style="padding-left: 12px" type="I">
      <li>
        In any cause of action arising under this policy, or certificate, cover
        note, or other confirmation of this insurance issued by your surplus
        lines agent, we will, at your request, submit to the jurisdiction of a
        court of competent jurisdiction within the United States. Nothing herein
        constitutes or should be understood to constitute a waiver of our rights
        to commence an action in any court of competent jurisdiction in the
        United States to remove an action to a United States District Court or
        to seek a transfer of a case to another court as permitted by the laws
        of the United States or of any state in the United States. In any suit
        instituted against us upon this policy, we will abide by the final
        decision of such court or of any appellate court in the event of appeal.
      </li>
      <br />
      <li>
        All lawful process may be served in any action, suit or proceeding
        instituted by, or on behalf of, you or any beneficiary under this
        policy, against us arising out of this policy, upon:
        <br />
        <p>
          <b>Corporate Creations Network Inc.</b><br />
          <b>3085 Mountainwood Circle</b><br />
          <b>Juneau, AK 99801</b><br />
          <b>Juneau County</b><br />
          <b>AK ENTITY NUMBER: 74930F</b><br />
          <b>Phone: (561) 694-8107</b><br />
        </p>
      </li>
      <br />
      <li>
        Pursuant to any law of any state, the District of Columbia or territory
        of the United States which makes provision therefore, we hereby
        designate the Superintendent, Commissioner or Director of Insurance or
        other applicable individual specified for that purpose in the applicable
        statute or regulation, or his successor or successors in office, as
        attorney or agent for receipt of lawful service of process as our true
        and lawful attorney upon whom may be served any lawful process in any
        action, suit or proceeding instituted by or on behalf of you or any
        beneficiary hereunder arising out of this policy of insurance, and we
        hereby designate the above-named as the person to whom the said
        individual, the surplus lines producer, or any applicable state surplus
        lines association or stamping office, is authorized to mail such process
        or a true copy thereof. The service of process as set forth above and
        below is cumulative to any other methods which may be provided by law
        for service of process upon us.
      </li>
    </ol>
    <p class="font-small">
      ALL OTHER TERMS, CONDITIONS, PROVISIONS AND EXCLUSIONS OF THIS POLICY
      REMAIN THE SAME.
    </p>
  </div>
</div>
